import { Box, Typography } from "@material-ui/core";
import { useState, useEffect } from "react";
import useStyles from '../../../assets/styles/styles';
import {useSelector } from "react-redux";



const DetailLaboratory = () => {
    const classes = useStyles();
    const modelLaboratoryReducer = useSelector(state => state.appointmentsReducer);
    const modelLaboratory = modelLaboratoryReducer?.laboratory;
    const [isMobile, setIsMobile] = useState(window.innerWidth < 760);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 760);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const laboratoryDate = modelLaboratory?.[0]?.fechaFormateada
        ? new Date(modelLaboratory[0].fechaFormateada).toLocaleDateString('es-ES')
        : "";

    const fields = [
        {
            label: "INSULINA",
            value: modelLaboratory?.[0]?.resultados?.find(item => item.nombre === "INSULINA")?.valor,
            condition: !!modelLaboratory?.[0]?.resultados?.find(item => item.nombre === "INSULINA")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "FERRITINA",
            value: modelLaboratory?.[0]?.resultados?.find(item => item.nombre === "FERRITINA")?.valor,
            condition: !!modelLaboratory?.[0]?.resultados?.find(item => item.nombre === "FERRITINA")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "TRIGLICÉRIDOS",
            value: modelLaboratory?.[0]?.resultados?.find(item => item.nombre === "TRIGLICÉRIDOS")?.valor,
            condition: !!modelLaboratory?.[0]?.resultados?.find(item => item.nombre === "TRIGLICÉRIDOS")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "GLUCEMIA",
            value: modelLaboratory?.[0]?.resultados?.find(item => item.nombre === "GLUCEMIA")?.valor,
            condition: !!modelLaboratory?.[0]?.resultados?.find(item => item.nombre === "GLUCEMIA")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
    ];

    const splitText = (text, wordLimit) => {
        if (typeof text !== 'string') return [];
        const descriptionEvolution = text.split(' ');
        const result = [];
        let currentLine = [];
        descriptionEvolution.forEach((word) => {
            currentLine.push(word);
            if (currentLine.length >= wordLimit) {
                result.push(currentLine.join(' '));
                currentLine = [];
            }
        });

        if (currentLine.length > 0) {
            result.push(currentLine.join(' '));
        }
        return result;
    };

    return (
        <>
            <Box className={`${classes.boxContent}`}>
                <>
                    <Box style={{ marginBottom: '10px' }}>
                        <Typography className={`${classes.txtCardDescription} ${classes.titleDetailLaboratory}`}>
                            RESULTADOS DE LABORATORIO {laboratoryDate && `| ${laboratoryDate}`}
                        </Typography>
                    </Box>

                    {fields.map((field, index) => (
                        field.condition && (
                            <Box key={index} style={{ marginBottom: "10px" }}>
                                <Typography className={field.labelClass}>{field.label}</Typography>
                                {isMobile
                                    ? splitText(field.value, 6).map((line, lineIndex) => (
                                        <Typography key={lineIndex} className={field.valueStyle}>{line}</Typography>
                                    ))
                                    : <Typography className={field.valueStyle}>{field.value}</Typography>
                                }
                               
                            </Box>
                        )
                    ))}
                </>
            </Box>
        </>
    );
};

export default DetailLaboratory;
